<template>
  <el-container>
    <el-container style="border-left: 1px solid #e7eaec" :style="conheight">
      <h3 class="flow_table_title">常用流程列表</h3>
      <collapse-search>
        <el-row>
          <el-col :span="6">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              style="margin-left: 0"
              @click="addCommonFlow"
              >{{ $t("common.add") }}</el-button
            >
            <!--      <el-button type="danger" size="small" @click="remove" icon="el-icon-delete" style="margin-left:3px;">删除</el-button>-->
            <eip-popconfirm-button
              type="danger"
              title="确定删除吗？"
              icon="el-icon-delete"
              @onConfirm="remove"
              style="margin-left: 3px"
              >{{ $t("common.delete") }}</eip-popconfirm-button
            >
          </el-col>
          <el-col :span="18">
            <el-input
              size="small"
              style="width: 380px"
              clearable
              :placeholder="$t('approvalItem.commonLanguage')"
              prefix-icon="el-icon-search"
              v-model="tableData"
            ></el-input>
            <el-button
              style="margin-left: 20px"
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="search('find')"
              >{{ $t("common.search") }}</el-button
            >
            <el-button size="small" icon="el-icon-refresh" @click="reset">{{
              $t("common.reset")
            }}</el-button>
          </el-col>
        </el-row>
      </collapse-search>
      <el-main class="approval-item__content">
        <el-table
          :data="rows"
          stripe
          border
          style="width: 100%"
          header-cell-class-name="todo-header-row"
          row-class-name="todo-row"
          size="medium"
          height="100%"
          :default-sort="{ prop: 'updateTime', order: 'ascending' }"
          v-loading.fullscreen.lock="fullscreenLoading"
          ref="elTable"
        >
          <el-table-column
            type="selection"
            sortable
            width="40"
          ></el-table-column>
          <el-table-column
            type="index"
            sortable
            width="45"
            :label="$t('common.seq')"
          ></el-table-column>
          <el-table-column
            prop="defName"
            label="流程名称"
            align="center"
          ></el-table-column>
          <el-table-column
            width="200"
            label="添加时间"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.creator == 'admin'">管理员添加</span>
              <span v-else>{{scope.row.createTime}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            :label="$t('common.operation')"
            align="center"
            width="150"
          >
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="45px">
        <el-row type="flex" justify="end">
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.page"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="20"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </el-row>
      </el-footer>
    </el-container>
    <eip-flow-dialog ref="eipFlowDialog" @onConfirm="dialogConfirm"></eip-flow-dialog>
  </el-container>
</template>

<script>
import EipFlowDialog from "@/components/dialog/EipFlowDialog.vue";
import EipPopconfirmButton from "@/components/eipControl/EipPopconfirmButton";

export default {
  name: "approvalItemList",
  components: {
    EipPopconfirmButton,
    EipFlowDialog
  },
  data() {
    return {
      tableData: "",
      fullscreenLoading: true,
      checkBoxData: [],
      conheight: { height: "" },
      pagination: { pageBean: { page: 1, pageSize: 20, showTotal: true } },
      rows: [],
      total: 0,
    };
  },
  methods: {
    getHeight() {
      this.conheight.height = window.innerHeight - 80 + "px";
    },
    remove() {
      let selection = this.$refs.elTable.selection;
      if(selection.length == 0){
        this.$message.error("请至少选择一条记录");
        return ;
      }
      for(let i = selection.length - 1 ; i >= 0 ; i --){
        if(selection[i].creator == 'admin'){
          selection.splice(i , 1);
        }
      }
      if(selection.length == 0){
        this.$message.error("无法删除管理员添加的常用流程")
        return;
      }
      let ids = [];
      selection.forEach(item=>{
        ids.push(item.id);
      })
      this.$http.remove(`${window.context.bpmModel}/bpmMobileCategory/v1/batchRemove?ids=${ids.join(',')}`).then(resp=>{
        if(resp.data && resp.data.state){
          this.$message.success(resp.data.message);
        }
        this.search("find");
      })
    },
    //Loading 加载中
    openFullScreen() {
      this.fullscreenLoading = true;
    },
    // 查询
    search(str) {
      this.openFullScreen();
      if (str == "find") {
        this.pagination.pageBean.page = 1;
      }
      let userId = this.$store.state.login.currentUser.userId;
      let querys = [];
      if (this.tableData) {
        querys.push({
          property: "def_name_",
          value: this.tableData,
          operation: "LIKE",
        });
      }
      let queryFilter = {
        pageBean: this.pagination.pageBean,
        querys
      };
      this.$http.post(`${window.context.bpmModel}/bpmMobileCategory/v1/getMyCommonFlow`, queryFilter).then(resp=>{
        let {data} = resp;
        this.total = data.total;
        this.rows = data.rows;
        this.fullscreenLoading = false;
      })

    },
    //重置
    reset() {
      this.tableData = "";
      this.search("find");
    },
    handleSizeChange: function (size) {
      //每页下拉显示数据
      this.pagination.pageBean.pageSize = size;
      this.search();
    },
    handleCurrentChange: function (currentPage) {
      //点击第几页
      this.pagination.pageBean.page = currentPage;
      this.search();
    },
    addCommonFlow(){
      this.$refs.eipFlowDialog.showDialog();
    },
    dialogConfirm(selection){
      if(!selection || selection.length == 0){
        this.$message.error("请至少添加一条流程")
        return ;
      }
      let defKyes = [];
      selection.forEach(item=>{
        defKyes.push(item.defKey);
      })
      this.$http.post(`${window.context.bpmModel}/bpmMobileCategory/v1/customAddCommonFlow`, defKyes).then(resp=>{
        this.search('find');
      })
    }
  },
  created() {
    window.temp1 = this;
    //页面高度设置
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    this.search("find");
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";

/deep/.el-table--border th{
  height: 44px;
  text-align: center;
  color: #000000;
  background: #e6e6e6;
  font-size: 14px;
}

/deep/.el-table--border tr:nth-child(even){
    background: rgb(240, 241, 241);
}

/deep/.el-table--border th,
/deep/.el-table--border td {
  //border-right:1px dashed #000000;
  border-bottom: 1px solid rgb(218, 218, 218);
  border-right: 1px dashed rgb(218, 218, 218);
}

/deep/.el-table--border tr:hover > td{
    background-color:#fdfdaf !important;
}

/deep/.el-table--medium th,
/deep/ .el-table--medium td {
  padding: 1px 0;
}
/deep/.el-table .cell {
  padding-left: 0px;
  padding-right: 0px;
}
/deep/.todo-subject,
/deep/.el-tooltip > span {
  font-size: 12px !important;
}
.el-table /deep/ tr.todo-row {
  font-size: 12px;
  color: $--color-text-regular;
  height: 41px;
}


.el-container {
  background-color: #fff;
}

.el-row {
  margin-bottom: 10px;
  margin-left: 20px;
}

/deep/.el-pagination {
  text-align: justify;
  margin: 0 auto;
  font-family: "微软雅黑", "宋体", Arial, sans-serif !important;
  font-size: 12px !important;
}
/deep/.pagination {
  margin-left: 0px;
  margin-top: 10px;
  text-align: left;
  font-family: "微软雅黑", "宋体", Arial, sans-serif;
  font-size: 12px !important;
}
.el-header {
  border-bottom: 1.5px solid #ededed;
}
/deep/.el-button {
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
  padding-top: 8px;
}
.todo-subject {
  cursor: pointer;
}
.approval-item__content {
  padding-top: 0;
}
.todo-subject {
  color: $--theme-color;
}
.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 15px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
